var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreditCardReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7351_6975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66211 13.3346H7.32878C4.82278 13.3346 3.57011 13.3346 2.73344 12.6746C2.60048 12.5693 2.47691 12.4526 2.36411 12.326C1.66211 11.5393 1.66211 10.3593 1.66211 8.0013C1.66211 5.6433 1.66211 4.46397 2.36411 3.67664C2.47655 3.55041 2.59966 3.43441 2.73344 3.32864C3.57011 2.66797 4.82278 2.66797 7.32878 2.66797H9.32878C11.8348 2.66797 13.0874 2.66797 13.9234 3.32797C14.0577 3.43464 14.181 3.55086 14.2934 3.67664C14.9261 4.38597 14.9888 5.4133 14.9954 7.33464M1.66211 6.0013H14.9954M14.9954 9.33464L10.9954 13.3346M14.9954 13.3346L10.9954 9.33464",
    stroke: "#EEF3F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7351_6975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCardReject);
export default __webpack_public_path__ + "static/media/IconCreditCardReject.eb77e37929d49d3358b057c3d24f792a.svg";
export { ForwardRef as ReactComponent };